import instance from './instance';

export async function postRoulette(email: string) {
  const res = await instance.post('/coupon/roulette', JSON.stringify({ email }));

  return res.data;
}
